import { useEffect } from 'react';
import { useGlobalStore } from 'lib/store/index';

export const useFinishInit = (fn) => {
  const complete = useGlobalStore(state => state.finishInitData);

  useEffect(() => {
    if (!complete) return;
    fn?.();
  }, [complete]);
};

